const socials = [
  {
    label: 'Twitter',
    icon: 'Twitter',
    href: 'https://twitter.com/darkmatterdefi',
  },
  {
    label: 'Telegram',
    icon: 'Telegram',
    href: 'https://t.me/darkmatterdefi',
  },
  {
    label: 'Discord',
    icon: 'Discord',
    href: 'https://discord.com/invite/VWFVkEfACd',
  },
  {
    label: 'Medium',
    icon: 'Medium',
    href: 'https://medium.com/@darkmatterdefi',
  },
]

export default socials
